import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'

const getWhitelabelConfigByOrganizationId = (organizationId) => axiosInstance.get(`${SERVICES.ORGANIZATION_CUSTOMIZATION}/${organizationId}`)
const getWhitelabelConfig = () => axiosInstance.get(`${SERVICES.ORGANIZATION_CUSTOMIZATION}`)
const createWhitelabelConfig = (organizationId, body) => axiosInstance.post(`${SERVICES.ORGANIZATION_CUSTOMIZATION}/${organizationId}`, body)
const updateWhitelabelConfig = (organizationId, body) => axiosInstance.patch(`${SERVICES.ORGANIZATION_CUSTOMIZATION}/${organizationId}`, body)
const deleteWhitelabelConfig = (organizationId) => axiosInstance.delete(`${SERVICES.ORGANIZATION_CUSTOMIZATION}/${organizationId}`)
const getEditConfiguration = (organizationId) => axiosInstance.get(`${SERVICES.ORGANIZATION_CUSTOMIZATION}/${organizationId}/edit`)

export default {
  getWhitelabelConfigByOrganizationId,
  getWhitelabelConfig,
  createWhitelabelConfig,
  updateWhitelabelConfig,
  deleteWhitelabelConfig,
  getEditConfiguration,
}
